<div class="note" *ngFor="let note of normalizedNotes">
  <nz-row>
    <nz-col [nzSpan]="12" class="title">
      {{ note | inspectionNoteTitle }}
    </nz-col>
    <nz-col [nzSpan]="12">
      {{ note | inspectionNoteText }}
    </nz-col>
  </nz-row>
</div>
